import type { ZustandStore } from '../store.type';
import type { NamedSet } from 'zustand/middleware';

type PageSpinnerState = {
	pageSpinner: {
		isLoading: boolean | number;
	};
};

type PageSpinnerActions = {
	setPageLoading: (isLoading: PageSpinnerState['pageSpinner']['isLoading']) => void;
};

export type PageSpinnerSlice = PageSpinnerState & PageSpinnerActions;

const pageSpinnerInitialState: PageSpinnerState = {
	pageSpinner: {
		isLoading: false,
	},
};

export function pageSpinnerSlice(set: NamedSet<ZustandStore>): PageSpinnerSlice {
	return {
		...pageSpinnerInitialState,
		setPageLoading(isLoading: PageSpinnerState['pageSpinner']['isLoading']): void {
			set(
				(state: PageSpinnerState) => {
					state.pageSpinner.isLoading = isLoading;
					return state;
				},
				false,
				'[setPageLoading]',
			);
		},
	};
}
